import React from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

const SectionContainer = styled.section`
  padding: ${theme.spacing['3xl']} 0;
`;

const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: ${theme.spacing['3xl']};
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const SectionTitle = styled.h2`
  font-size: ${theme.fontSizes['4xl']};
  font-weight: 700;
  color: ${theme.colors.text};
  margin-bottom: ${theme.spacing.md};
  
  @media (max-width: ${theme.breakpoints.md}) {
    font-size: ${theme.fontSizes['3xl']};
  }
`;

const SectionSubtitle = styled.p`
  font-size: ${theme.fontSizes.base};
  color: ${theme.colors.textLight};
  line-height: 1.7;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 ${theme.spacing.lg};
`;

interface SectionProps {
  id?: string;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  className?: string;
}

export const Section: React.FC<SectionProps> = ({
  id,
  title,
  subtitle,
  children,
  className
}) => {
  return (
    <SectionContainer id={id} className={className}>
      <Container>
        <SectionHeader>
          <SectionTitle>{title}</SectionTitle>
          {subtitle && <SectionSubtitle>{subtitle}</SectionSubtitle>}
        </SectionHeader>
        {children}
      </Container>
    </SectionContainer>
  );
};